module.exports = __webpack_public_path__ + "static/img-main-80905aefeea41ee10a378314211fd97e.png";